export var DocumentType;
(function (DocumentType) {
    DocumentType["QUOTE"] = "QUOTE";
    DocumentType["INVOICE"] = "INVOICE";
    DocumentType["CONTRACT"] = "CONTRACT";
    DocumentType["OTHER"] = "OTHER";
})(DocumentType || (DocumentType = {}));
//# sourceMappingURL=document.js.map